<template lang="pug">
.backup-card-table
  card-table(:total-items='data.length' breakpoint-size='lg')
    template(v-for='(item, index) in data' v-slot:[`card-${index}`]='{}')
      .position-relative
        .mb-1 {{ $t('backupCardTable.status') }}: {{ getStatus(item.status) }}
        .mb-1 {{ $t('backupCardTable.created_at') }}: {{ item.created_at | dateTime }} {{ item.created_at | time }}
        .mb-1 {{ $t('backupCardTable.expire_at') }}: {{ item.expire_at | dateTime }} {{ item.expire_at | time }}
        .dropdown.text-end.mt-2(
          style='position: absolute; top: -1rem; right: -1rem; font-size: 1.5em'
        )
          button#backupActions.dropdown-toggle.px-0(data-bs-toggle='dropdown')
    template(v-slot:table-head)
      th(style='width: 10%')
        .d-flex
          span.text {{ $t('backupCardTable.status') }}
          icon.ms-2(
            name='circle-question'
            style='cursor: help'
            v-tooltip:top='$t("backupCardTable.tooltipStatus")'
          )
      th(style='width: 20%') {{ $t('backupCardTable.created_at') }}
      th(style='width: 20%') {{ $t('backupCardTable.expire_at') }}
      th(style='width: 6%')
    template(v-for='(item, index) in data' v-slot:[`table-row-${index}`]='{}')
      td {{ getStatus(item.status) }}
      td {{ item.created_at | dateTime }} {{ item.created_at | time }}
      td {{ formatExpireAt(item.expire_at) }}
      td
        .d-flex
          button(
            :title='$t("backupCardTable.viewDetails")'
            @click='goToPage(item)'
            type='button'
            v-if='canViewDetails(item.status)'
          )
            icon.icon--blue(name='file-lines')
          button(
            :aria-controls='`collapse-row-${index}`'
            :data-bs-target='`#collapse-row-${index}`'
            :title='$t("backupCardTable.viewInfo")'
            aria-expanded='false'
            data-bs-toggle='collapse'
            type='button'
          )
            icon.icon--blue(name='magnifying-glass')
          .dropdown.text-end.mt-0
            button#backupActions.dropdown-toggle.px-0(
              data-bs-toggle='dropdown'
              style='width: 1em'
            )
      .d-table-row
        td.collapse-row.p-0(colspan='6')
          .collapse.collapse-row-block(
            :id='`collapse-row-${index}`'
            data-bs-parent='.backup-card-table'
          )
            .p-3
              .mb-1
                strong {{ $t('backupCardTable.period') }}:
                span.ms-1 {{ item.metadata.date_start | dateTime }} {{ $t('backupCardTable.period_to') }} {{ item.metadata.date_end | dateTime }}
              .mb-1
                strong {{ $t('backupCardTable.includeBackgroundSheetLabel') }}:
                icon.ms-1(
                  :name='getStatusIcon(item.metadata.include_background_sheet)'
                  :style='{ color: getStatusColor(item.metadata.include_background_sheet) }'
                )
              .mb-1
                strong {{ $t('backupCardTable.includeStorageDocumentsLabel') }}:
                icon.ms-1(
                  :name='getStatusIcon(item.metadata.include_storage_documents)'
                  :style='{ color: getStatusColor(item.metadata.include_storage_documents) }'
                )
</template>

<script>
import CardTable from '@/ui/organisms/CardTable.vue';
import BackupState from '@/enums/BackupState';
import Icon from '@/ui/atoms/Icon.vue';

export default {
  name: 'BackupCardTable',
  components: {
    CardTable,
    Icon,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedTeam: {},
    };
  },
  methods: {
    canViewDetails(status) {
      return ['completed', 'expired'].includes(status);
    },
    getStatus(status) {
      return BackupState.getText(status, this.$i18n);
    },
    getStatusIcon(value) {
      return value ? 'check' : 'xmark';
    },
    getStatusColor(value) {
      return value ? '#28a745' : '#dc3545';
    },
    goToPage(item) {
      localStorage.setItem('selectedBackup', JSON.stringify(item));
      this.$router.push({
        name: 'account.backup.details-backup',
        params: { uuid: item.id },
      });
    },
    formatExpireAt(value) {
      if (!value) return '-';
      return `${this.$options.filters.dateTime(
        value
      )} ${this.$options.filters.time(value)}`;
    },
  },
};
</script>
